export default __webpack_public_path__ + "static/media/money_and_sense.90e8e89a.png";